import React from 'react';
import MedsenderLogo from '../../assets/img/redesign/medsender_icon.png';
import './loadingMask.scss';

const LoadingMask = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="loading-mask">
      <div className="loading-mask-content">
        <div
          className="loading-mask-logo-wrapper"
          style={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none'
          }}
        >
          <img
            className="loading-mask-logo"
            src={MedsenderLogo}
            height={150}
            alt="Medsender Logo"
            draggable="false"
            style={{
              pointerEvents: 'none',
              userSelect: 'none',
              WebkitUserSelect: 'none',
              MozUserSelect: 'none',
              msUserSelect: 'none'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingMask;
